import { ReactNode } from "react";

import CategoryStoryListingLayout from "../CategoryStoryListingLayout";
import { CategoryLayoutElementProps } from "../types/types";

export default function CategoryStoryListingBlock({
  data,
}: CategoryLayoutElementProps): ReactNode {
  if (!data.mainContentBlock || data.mainContentBlock.length === 0) {
    return null;
  }

  return (
    <CategoryStoryListingLayout
      data={{
        mainContentBlock: data.mainContentBlock,
        imu: data.imu1,
      }}
    />
  );
}
